import { jsx as t, jsxs as w, Fragment as mt } from "react/jsx-runtime";
import * as v from "react";
import Vt, { useMemo as S, memo as V, useCallback as B, useEffect as vt, createContext as Pe, useContext as Oe, useState as Dt, useRef as ct } from "react";
import { Row as dt, Col as U, Popover as Mt, Drawer as Ee, notification as Ae, Form as ot, Collapse as ze, Tabs as De } from "antd";
import { u as F } from "./styled-components.browser.esm-BFmoFexH.js";
import { notEmpty as je, getIndexFromID as rt, IconContainer as O, CopyDuplicate as Ne, TooltipPopover as Ie, SortableContainerContext as _e, SortableOverlay as He, SortableItem as We, getIdFromIndex as te, WrapperItem as Be, SelectSelector as ee, WrapperRoot as Ct } from "@biron-data/react-components";
import { g as qe } from "./filters-Cwo0Aj2k.js";
import { F as pe, P as Ge } from "./PeriodSelector-BPitTrQ8.js";
import { useHasGrowthApplied as Ue, useHasFilterApplied as Ke, useHasPeriodApplied as Ze, useHasDisplayOptionApplied as Xe } from "./metricDisplay/MetricDisplay.hooks.js";
import { MetricOptionsFormKeys as X, ColorTypes as W } from "./selector/metrics/options/MetricOptionForm.types.js";
import "./useResizeDetector-sfyDtky2.js";
import { l as Y } from "./lodash-DeBCDn4U.js";
import { d as me, c as Wt, F as ge, r as wt, o as jt, v as Nt, h as oe, b as It, n as ne, t as Je } from "./utils-wNl4DVdv.js";
import "./description/DimensionDescription.js";
import Qe from "./description/MetricDescription.js";
import "./description/ViewDescription.js";
import "./FormFooter.js";
import "./metricDetails/MetricDetails.js";
import "./metricDisplay/MetricDisplay.js";
import "./selector/comps/box/Box.js";
import "./selector/comps/box/FilterInputs.js";
import "./selector/comps/box/FilterTypeDescription.js";
import "./selector/comps/box/FilterTypeDropDown.js";
import "./selector/comps/box/inputs/FilterPattern.js";
import "./selector/comps/box/inputs/FilterRange.js";
import "./selector/comps/box/inputs/FilterScalar.js";
import "./selector/comps/box/inputs/FilterValueMatch.js";
import "./selector/comps/box/inputs/SuffixPrefixWrapper.js";
import Ye from "./selector/comps/BoxesWrapper.js";
import "./selector/comps/BoxesWrapperWithResume.js";
import "./selector/comps/boxWithDescription/BoxWithDescription.js";
import "./selector/filters/addFilterPanel/MultipleSelectWithOptionList.js";
import "./selector/filters/addFilterPanel/OptionList.js";
import { consolidateUniversalConfFilterToDimension as Ve } from "./selector/filters/DimensionFilterSelector/DimensionFilterSelector.utils.js";
import { useEventResolver as ue, useLanguageResolver as nt } from "@biron-data/react-contexts";
import { useDimensionOptions as Me } from "./hooks/useDimensionOptions.js";
import { getDefaultDimensionPredicate as to } from "./selector/filters/FilterPopover.utils.js";
import eo from "./selector/filters/FilterPopover.js";
import "./selector/filters/MetricFilterSelector/MetricFilterSelector.js";
import "dayjs";
import { T as ie } from "./period-BbmcGyLd.js";
import "./selector/limits/LimitsSelector.js";
import "./selector/limits/SingleLimitSelector.js";
import "./selector/metrics/display/MetricDisplayResume.js";
import "./selector/metrics/display/MetricFiltersResume.js";
import { D as he, w as oo, m as no } from "./MetricGrowthResume-ClJnPTa-.js";
import io from "./selector/metrics/display/MetricOptionsResume.js";
import "./selector/metrics/display/MetricPeriodResume.js";
import ro from "./selector/metrics/MetricAdd.js";
import { ColWithLeftMargin as _t, SortableRow as lo } from "./selector/utils.js";
import { MetricTarget as gt, MetricGrowthType as $t } from "./configuration/types.js";
import { useColumnLayout as xt, useIsAxisOptionAllowed as so, useAddSecondaryAxisOption as ao, useModifiedSecondaryAxisOption as co, useDefaultGrowth as fo } from "./selector/metrics/hooks.js";
import { p as po } from "./SlicerSelector-VIUZXwzA.js";
import { getAvailableDimensions as mo } from "./configuration/useRequirements.js";
import go from "./selector/metrics/SingleMetricSelector.js";
import { useSelectorLayout as it } from "./layout/useSelectorLayout.js";
import "./selector/metrics/MetricSelectorCascader.js";
import "./selector/metrics/MetricSelectorSelect.js";
import Bt from "./selector/metrics/options/selectors/CustomDisplaySelector.js";
import { MetricOptionContainer as yt, MetricOptionContainerRow as bt } from "./selector/metrics/options/selectors/MetricOptionContainerRow.js";
import uo from "./selector/metrics/options/selectors/ActionSelector.js";
import ho from "./selector/metrics/options/selectors/TypeSelector.js";
import wo from "./selector/metrics/options/selectors/PeriodSelector.js";
import xo from "./selector/metrics/options/selectors/GrowthInvertSelector.js";
import vo from "./selector/metrics/options/selectors/DecimalsSelector.js";
import Co from "./selector/metrics/options/selectors/DetailsSelector.js";
import yo from "./selector/metrics/options/selectors/IntervalSelector.js";
import bo from "./selector/metrics/options/selectors/ColorSelector.js";
import { b as ko } from "./GradientSelector.utils-BKTc3JRX.js";
import { useOnValuesChanges as Lo } from "./selector/metrics/options/selectors/MetricDisplayOptionSelector.hooks.js";
import To from "./selector/metrics/options/MetricOptionsFormFooter.js";
import { h as So, i as $o, l as Fo, r as Ro } from "./index-a388f2ac-Cf1pu7LW.js";
import "./selector/metrics/options/selectors/InputSelector.js";
import "./selector/slicers/SingleSlicerSelector.js";
import "./selector/sorts/MultipleSortSelector.js";
import "./selector/sorts/OrderBySelector.js";
import "./SortSelectorSelect-DdwXZK8T.js";
import "./selector/target/TargetSelector.js";
import "./tests/dummyModel.js";
import "./tooltipContent/TooltipContent.Dimension.js";
import "./tooltipContent/TooltipContent.Metric.js";
import "./layout/selectorLayout.js";
import { n as Po, g as re, _ as et, o as we, k as xe, j as Oo, i as le, h as qt } from "./raf-1AcQTkO6.js";
import { g as Eo, u as Ao, b as zo } from "./presets-P0FA1xhk.js";
import { getFilterResume as Do } from "./selector/comps/box/utils.js";
const kt = (n, e) => S(() => n && typeof n == "object" ? Object.assign([], Object.entries(n)).map(([i, o]) => {
  const r = e ? e.filter((s) => s.field === i).map((s) => s.message) : [];
  return {
    name: [i],
    errors: r,
    value: o
  };
}) : [], [n, e]);
function jo(n, e) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: e
  }, n), /* @__PURE__ */ v.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z",
    clipRule: "evenodd"
  }));
}
const ve = v.forwardRef(jo);
function No(n, e) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: e
  }, n), /* @__PURE__ */ v.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}
const Ft = v.forwardRef(No);
function Io(n, e) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: e
  }, n), /* @__PURE__ */ v.createElement("path", {
    fillRule: "evenodd",
    d: "M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z",
    clipRule: "evenodd"
  }));
}
const Ce = v.forwardRef(Io);
function _o(n, e) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: e
  }, n), /* @__PURE__ */ v.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}
const Ho = v.forwardRef(_o);
function Wo(n, e) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: e
  }, n), /* @__PURE__ */ v.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
  }), /* @__PURE__ */ v.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }));
}
const Rt = v.forwardRef(Wo);
function Bo(n, e) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: e
  }, n), /* @__PURE__ */ v.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
  }));
}
const qo = v.forwardRef(Bo), ut = (n) => /* @__PURE__ */ v.createElement("svg", { width: 14, height: 8, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ v.createElement("path", { d: "M13 7H1V1", stroke: "#BEC5CC", strokeLinecap: "round", strokeLinejoin: "round" })), Go = (n) => /* @__PURE__ */ v.createElement("svg", { width: 12, height: 12, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-6 h-6", ...n }, /* @__PURE__ */ v.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" })), Uo = V(function({
  value: e = [],
  availableDimensions: i,
  getPopupContainer: o,
  onChange: r,
  span: s = 14,
  GACategory: l,
  loadDictionaryEntries: u,
  consolidateInPlace: m = !1,
  isEditable: h = !0
}) {
  const d = ue(), c = S(
    () => i.filter((b) => !!b.dictionaryCode),
    [i]
  ), g = B((b) => {
    const k = b.map((C) => Ve(C)).filter(je);
    return m ? r == null ? void 0 : r(me(k, c)) : r == null ? void 0 : r(k);
  }, [c, m, r]);
  vt(() => {
    const b = e.filter((k) => i.find((C) => C.code === k.reference.code));
    Y.isEqual(b, e) || g(b);
  }, [i, g, e]);
  const y = Me(c), L = B((b) => {
    d.capture({
      category: l,
      action: "add_dimension_filter"
    }), g(b);
  }, [l, d, g]);
  return /* @__PURE__ */ t("div", { className: "filter-selector", children: /* @__PURE__ */ t(dt, { children: /* @__PURE__ */ w(U, { span: s, children: [
    /* @__PURE__ */ t(Ko, { filters: e, seeDescription: !0, layout: "column", onFiltersChange: g, numberOfFilterPerLine: 1, bordered: !0, getPopupContainer: o, GACategory: l, $nbfilters: e.length, loadDictionaryEntries: u, isEditable: h }),
    /* @__PURE__ */ t(Zo, { children: /* @__PURE__ */ t(eo, { isSimpleInput: !0, filters: e, getPopupContainer: o, getOptions: y, onTemporaryFiltersChange: L, colorized: !0, allowMultipleSelection: !1, getDefaultValue: to }) })
  ] }) }) });
}), Ko = F(Ye)`
    ${({ $nbfilters: n }) => n > 0 ? "margin-bottom: 5px;" : ""}
`, Zo = F.div`

    &&& .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
        background-color: white;
        border-color: var(--border-color-input) !important;
    }
`;
var ye = /* @__PURE__ */ Pe({});
function be(n) {
  var e;
  return n == null || (e = n.getRootNode) === null || e === void 0 ? void 0 : e.call(n);
}
function Xo(n) {
  return be(n) instanceof ShadowRoot;
}
function Jo(n) {
  return Xo(n) ? be(n) : null;
}
function Qo(n) {
  return n.replace(/-(.)/g, function(e, i) {
    return i.toUpperCase();
  });
}
function Yo(n, e) {
  Po(n, "[@ant-design/icons] ".concat(e));
}
function se(n) {
  return re(n) === "object" && typeof n.name == "string" && typeof n.theme == "string" && (re(n.icon) === "object" || typeof n.icon == "function");
}
function ae() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(n).reduce(function(e, i) {
    var o = n[i];
    switch (i) {
      case "class":
        e.className = o, delete e.class;
        break;
      default:
        delete e[i], e[Qo(i)] = o;
    }
    return e;
  }, {});
}
function Ht(n, e, i) {
  return i ? /* @__PURE__ */ Vt.createElement(n.tag, et(et({
    key: e
  }, ae(n.attrs)), i), (n.children || []).map(function(o, r) {
    return Ht(o, "".concat(e, "-").concat(n.tag, "-").concat(r));
  })) : /* @__PURE__ */ Vt.createElement(n.tag, et({
    key: e
  }, ae(n.attrs)), (n.children || []).map(function(o, r) {
    return Ht(o, "".concat(e, "-").concat(n.tag, "-").concat(r));
  }));
}
function ke(n) {
  return Eo(n)[0];
}
function Le(n) {
  return n ? Array.isArray(n) ? n : [n] : [];
}
var Vo = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Mo = function(e) {
  var i = Oe(ye), o = i.csp, r = i.prefixCls, s = Vo;
  r && (s = s.replace(/anticon/g, r)), vt(function() {
    var l = e.current, u = Jo(l);
    Ao(s, "@ant-design-icons", {
      prepend: !0,
      csp: o,
      attachTo: u
    });
  }, []);
}, tn = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], at = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function en(n) {
  var e = n.primaryColor, i = n.secondaryColor;
  at.primaryColor = e, at.secondaryColor = i || ke(e), at.calculated = !!i;
}
function on() {
  return et({}, at);
}
var lt = function(e) {
  var i = e.icon, o = e.className, r = e.onClick, s = e.style, l = e.primaryColor, u = e.secondaryColor, m = we(e, tn), h = v.useRef(), d = at;
  if (l && (d = {
    primaryColor: l,
    secondaryColor: u || ke(l)
  }), Mo(h), Yo(se(i), "icon should be icon definiton, but got ".concat(i)), !se(i))
    return null;
  var c = i;
  return c && typeof c.icon == "function" && (c = et(et({}, c), {}, {
    icon: c.icon(d.primaryColor, d.secondaryColor)
  })), Ht(c.icon, "svg-".concat(c.name), et(et({
    className: o,
    onClick: r,
    style: s,
    "data-icon": c.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, m), {}, {
    ref: h
  }));
};
lt.displayName = "IconReact";
lt.getTwoToneColors = on;
lt.setTwoToneColors = en;
function Te(n) {
  var e = Le(n), i = xe(e, 2), o = i[0], r = i[1];
  return lt.setTwoToneColors({
    primaryColor: o,
    secondaryColor: r
  });
}
function nn() {
  var n = lt.getTwoToneColors();
  return n.calculated ? [n.primaryColor, n.secondaryColor] : n.primaryColor;
}
var rn = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
Te(zo.primary);
var ft = /* @__PURE__ */ v.forwardRef(function(n, e) {
  var i = n.className, o = n.icon, r = n.spin, s = n.rotate, l = n.tabIndex, u = n.onClick, m = n.twoToneColor, h = we(n, rn), d = v.useContext(ye), c = d.prefixCls, g = c === void 0 ? "anticon" : c, y = d.rootClassName, L = Oo(y, g, le(le({}, "".concat(g, "-").concat(o.name), !!o.name), "".concat(g, "-spin"), !!r || o.name === "loading"), i), b = l;
  b === void 0 && u && (b = -1);
  var k = s ? {
    msTransform: "rotate(".concat(s, "deg)"),
    transform: "rotate(".concat(s, "deg)")
  } : void 0, C = Le(m), $ = xe(C, 2), a = $[0], A = $[1];
  return /* @__PURE__ */ v.createElement("span", qt({
    role: "img",
    "aria-label": o.name
  }, h, {
    ref: e,
    tabIndex: b,
    onClick: u,
    className: L
  }), /* @__PURE__ */ v.createElement(lt, {
    icon: o,
    primaryColor: a,
    secondaryColor: A,
    style: k
  }));
});
ft.displayName = "AntdIcon";
ft.getTwoToneColor = nn;
ft.setTwoToneColor = Te;
var ln = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, sn = function(e, i) {
  return /* @__PURE__ */ v.createElement(ft, qt({}, e, {
    ref: i,
    icon: ln
  }));
}, Se = /* @__PURE__ */ v.forwardRef(sn);
process.env.NODE_ENV !== "production" && (Se.displayName = "EllipsisOutlined");
var an = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" }, cn = function(e, i) {
  return /* @__PURE__ */ v.createElement(ft, qt({}, e, {
    ref: i,
    icon: an
  }));
}, $e = /* @__PURE__ */ v.forwardRef(cn);
process.env.NODE_ENV !== "production" && ($e.displayName = "LeftOutlined");
const dn = (n, e, i, o) => {
  if (!n)
    return "";
  switch (n) {
    case gt.COLUMN:
      return `${e.get(`configuration-metric-target.${gt.COLUMN}`)} ${i && o ? i + o : ""}`;
    case gt.BAR:
      return `${e.get(`configuration-metric-target.${gt.BAR}`)} ${o && !i ? o : ""}`;
    default:
      return e.get(`configuration-metric-target.${n}`);
  }
}, fn = V(({
  id: n,
  environmentId: e,
  availableDimensions: i,
  value: o,
  canInvert: r,
  onChange: s,
  viewsWithMetrics: l,
  optionsDisabled: u,
  configuration: m,
  numberOfSlicer: h,
  getPopupContainer: d,
  isAxisOptionDisabled: c = !1,
  displayType: g,
  dashboardSelection: y,
  period: L,
  metaModel: b,
  setActiveKey: k,
  isAxisOptionAvailable: C,
  activeKey: $,
  handleDuplicate: a,
  handlePaste: A,
  onCopy: M,
  copiedMetric: E,
  isOptionsDisplayed: K,
  setIsOptionsDisplayed: N,
  getMoreInformationLink: D,
  loadDictionaryEntries: J,
  loadPeriods: p,
  withPasteOptions: Q,
  withDisplayOptions: _
}) => {
  var Gt, Ut, Kt, Zt, Xt, Jt, Qt, Yt;
  const T = nt(), I = ue(), z = it(), H = S(() => Wt({
    dashboardSelection: y,
    chartPeriod: L
  }, !0), [y, L]), f = he(H), x = B((G) => {
    o && s(rt(n), {
      ...o,
      ...G
    }), N(!1);
  }, [n, s, N, o]), R = B(() => {
    var G;
    o && !c && s(rt(n), {
      ...o,
      extraConf: {
        ...o == null ? void 0 : o.extraConf,
        isDisplayedOnSecondaryAxis: !((G = o == null ? void 0 : o.extraConf) != null && G.isDisplayedOnSecondaryAxis)
      }
    });
  }, [n, c, s, o]), P = S(() => c ? T.get("configuration-chart-cannot-modify-axis") : o != null && o.extraConf && (o != null && o.extraConf.isDisplayedOnSecondaryAxis) ? T.get("configuration-chart-set-to-first-axis") : T.get("configuration-chart-set-to-second-axis"), [c, T, o == null ? void 0 : o.extraConf]), tt = S(() => /* @__PURE__ */ w("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ t("path", { d: "M6 17.8161L9.17284 14.2695M6.8823 16.8299L10.0551 13.2833", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M12.9449 14.2674L16.1177 10.7209M13.8272 13.2812L17 9.73467", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M10.0551 13.2833L12.3161 14.0533M10.6839 13.4974L12.9449 14.2674", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M20.48 6.36C20.24 6.68 19.76 6.68 19.52 6.36L17.72 3.96C17.4233 3.56446 17.7056 3 18.2 3L21.8 3C22.2944 3 22.5767 3.56446 22.28 3.96L20.48 6.36Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M2 21H16.8661M6.13393 21H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M20 9L20 21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
  ] }), []), Lt = S(() => /* @__PURE__ */ w("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ t("path", { d: "M6 17.8161L9.17284 14.2695M6.8823 16.8299L10.0551 13.2833", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M12.9449 14.2674L16.1177 10.7209M13.8272 13.2812L17 9.73467", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M10.0551 13.2833L12.3161 14.0533M10.6839 13.4974L12.9449 14.2674", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t("path", { d: "M2 21H16.8661M6.13393 21H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M3.48 6.36C3.24 6.68 2.76 6.68 2.52 6.36L0.72 3.96C0.423344 3.56446 0.705573 3 1.2 3L4.8 3C5.29443 3 5.57666 3.56446 5.28 3.96L3.48 6.36Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M3 9L3 21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
  ] }), []), Tt = o && ((Kt = (Ut = (Gt = l.find(({ code: G }) => G === o.viewCode)) == null ? void 0 : Gt.metrics) == null ? void 0 : Ut.find(({ code: G }) => G === o.metricCode)) == null ? void 0 : Kt.description), q = S(
    () => E === void 0 || (E == null ? void 0 : E.additionalFilters.length) === 0 || E != null && E.additionalFilters.every((G) => i.find((Re) => Re.code === G.dimensionCode)) ? 1 : 0,
    [i, E]
  ), Z = xt(z, "none", 2), pt = xt(z, "auto", 8), St = S(() => o ? /* @__PURE__ */ t(Rn, { environmentId: e, availableDimensions: i, id: n, value: o, configuration: m, onValuesChange: x, getPopupContainer: d, dashboardSelection: y, displayType: g, canInvert: r, dayDifference: f, period: L, activeKey: $, metaModel: b, onCancel: () => {
    N(!1);
  }, loadDictionaryEntries: J, loadPeriods: p, layout: z, withDisplayOptions: _ }) : /* @__PURE__ */ t(mt, {}), [$, i, r, m, y, f, g, e, d, n, z, J, p, b, x, L, N, o, _]), Fe = S(
    () => z === "default" ? /* @__PURE__ */ t(
      Mt,
      {
        trigger: "click",
        open: K,
        destroyTooltipOnHide: !0,
        onOpenChange: (G) => {
          N(G), k(X.filters);
        },
        overlayInnerStyle: {
          backgroundColor: "var(--popup-background)"
        },
        overlayClassName: "metric-options-popup",
        arrow: !1,
        align: {
          points: ["tr", "br"],
          offset: [328, 0],
          targetOffset: [0, 0]
        },
        getPopupContainer: d,
        content: St,
        children: /* @__PURE__ */ t(O, { clickable: !0, children: /* @__PURE__ */ t(Rt, {}) })
      }
    ) : /* @__PURE__ */ t(O, { clickable: !0, onClick: () => {
      N(!0), k(X.filters);
    }, children: /* @__PURE__ */ t(Rt, {}) }),
    [d, K, z, St, k, N]
  );
  return /* @__PURE__ */ w(mt, { children: [
    /* @__PURE__ */ w(pn, { children: [
      /* @__PURE__ */ t(ce, { $value: 5, ...Z, children: Tt && /* @__PURE__ */ t(Qe, { metric: o, timeInterval: H, getMoreInformationLink: D }) }),
      !u && /* @__PURE__ */ w(mt, { children: [
        /* @__PURE__ */ t(de, { ...Z, title: T.get("configuration-metric-options.info.options"), children: o ? Fe : /* @__PURE__ */ t(mt, {}) }),
        Q && /* @__PURE__ */ t(de, { ...Z, title: T.get("configuration-metric-options.info.paste/duplicate"), children: /* @__PURE__ */ t(Ne, { handleDuplicate: a, onCopy: M }) }),
        Q && /* @__PURE__ */ t(_t, { $value: 5, ...Z, title: T.get("configuration-metric-options.info.more"), children: /* @__PURE__ */ t(
          Mt,
          {
            trigger: "click",
            placement: "rightTop",
            overlayClassName: "paste-options",
            content: /* @__PURE__ */ w(mn, { children: [
              /* @__PURE__ */ w(st, { onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-options"
                }), A(["decimals", "details", "units", "color", "overridePeriod", "overridePeriodLabel", "additionalFilters", "additionalFiltersLabel", "growthType", "growthPeriod", "growthInvert", "growthLabel"]);
              }, children: [
                /* @__PURE__ */ t(O, { clickable: !0, children: /* @__PURE__ */ t(Rt, {}) }),
                T.get("configuration-metric-options.paste.metric-options")
              ] }),
              /* @__PURE__ */ w(st, { $margin: 8, $enabled: q, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-filters"
                }), A(["additionalFilters", "additionalFiltersLabel"]);
              }, children: [
                /* @__PURE__ */ t(O, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ut, {}) }),
                /* @__PURE__ */ t(O, { clickable: q === 1, children: /* @__PURE__ */ t(qo, {}) }),
                T.get("configuration-metric-options.paste.filters")
              ] }),
              /* @__PURE__ */ w(st, { $margin: 8, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-period"
                }), A(["overridePeriod", "overridePeriodLabel"]);
              }, children: [
                /* @__PURE__ */ t(O, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ut, {}) }),
                /* @__PURE__ */ t(O, { clickable: !0, children: /* @__PURE__ */ t(pe, {}) }),
                T.get("configuration-metric-options.paste.period")
              ] }),
              /* @__PURE__ */ w(st, { $margin: 8, $enabled: (Zt = o == null ? void 0 : o.metricDef) != null && Zt.asRatio ? 0 : 1, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-growth"
                }), A(["growthType", "growthPeriod", "growthInvert", "growthLabel"]);
              }, children: [
                /* @__PURE__ */ t(O, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ut, {}) }),
                /* @__PURE__ */ t(O, { clickable: !0, children: /* @__PURE__ */ t(Ce, {}) }),
                T.get("configuration-metric-options.paste.growth")
              ] }),
              /* @__PURE__ */ w(st, { $margin: 8, onClick: () => {
                I.capture({
                  category: "metric-options",
                  action: "paste-display"
                }), A([
                  "color",
                  "decimals",
                  "details",
                  ...o && ge(o) ? ["units"] : []
                ]);
              }, children: [
                /* @__PURE__ */ t(O, { size: 12, color: "var(--medium-grey)", children: /* @__PURE__ */ t(ut, {}) }),
                /* @__PURE__ */ t(O, { clickable: !0, children: /* @__PURE__ */ t(ve, {}) }),
                T.get("configuration-metric-options.paste.display")
              ] })
            ] }),
            children: /* @__PURE__ */ t(O, { clickable: !0, children: /* @__PURE__ */ t(Se, {}) })
          }
        ) })
      ] }),
      C && /* @__PURE__ */ t(ce, { $value: 7, ...Z, children: /* @__PURE__ */ t(
        Ie,
        {
          size: "small",
          mouseEnterDelay: 0.5,
          content: P,
          children: /* @__PURE__ */ t(gn, { $defaultvalue: (Xt = o == null ? void 0 : o.extraConfDefaultProperties) != null && Xt.isDisplayedOnSecondaryAxis ? 1 : 0, children: /* @__PURE__ */ t(
            O,
            {
              onClick: R,
              disable: c,
              color: ((Jt = o == null ? void 0 : o.extraConfDefaultProperties) == null ? void 0 : Jt.isDisplayedOnSecondaryAxis) === !1 || (Qt = o == null ? void 0 : o.extraConf) != null && Qt.isDisplayedOnSecondaryAxis ? "var(--primary)" : void 0,
              clickable: !0,
              children: (Yt = o == null ? void 0 : o.extraConf) != null && Yt.isDisplayedOnSecondaryAxis ? tt : Lt
            }
          ) })
        }
      ) }),
      /* @__PURE__ */ t(_t, { $value: 5, ...pt, children: /* @__PURE__ */ t(un, { children: m != null && m.metricTarget ? dn(m.metricTarget[rt(n)], T, h, n) : "" }) })
    ] }),
    z === "compact" && /* @__PURE__ */ t(Ee, { open: K, onClose: () => N(!1), width: 700, closeIcon: /* @__PURE__ */ t($e, {}), children: St })
  ] });
}), pn = F(dt)`
`, mn = F.div`
    display: flex;
    flex-direction: column;
    padding: 4px 10px;
`, st = F.div`
    text-align: center;
    flex-basis: 100%;
    display: flex;
    gap: 10px;
    flex-direction: row;
    align-items: center;
    ${({ $margin: n }) => n ? `margin-left: ${n}px;` : ""}
    ${({ $enabled: n }) => n === void 0 || n === 1 ? `
    &:hover {
        cursor: pointer;
        color: var(--primary);
    }
    ` : `
    opacity: 0.2;
    * {
      cursor: unset;
    }
    `}



`, gn = F.div`
    margin-right: 5px;
    margin-left: 5px;
    padding-bottom: 3px;

    * {
        ${({ $defaultvalue: n }) => n ? "opacity: 0.85;" : ""}
    }
`, un = F.div`
    color: var(--light-grey);
    height: 100%;
    display: flex;
    align-items: center;
`, ce = F(_t)`
    align-content: center;
    align-items: center;
    display: flex;
    justify-content: center;
`, de = F(U)`
    display: flex;
    align-items: center;

    &:hover {
        color: var(--primary);
    }`, fe = V(function({
  id: e,
  environmentId: i,
  value: o,
  canInvert: r,
  canRemove: s,
  onChange: l,
  handleAdd: u,
  onDelete: m,
  groupMetricsByView: h,
  viewsWithMetrics: d,
  unavailableViews: c,
  optionsDisabled: g,
  configuration: y,
  numberOfSlicer: L,
  getPopupContainer: b,
  isAxisOptionAvailable: k = !1,
  displayType: C,
  dashboardSelection: $,
  period: a,
  metaModel: A,
  onCopy: M,
  copiedMetric: E,
  getMoreInformationLink: K,
  loadDictionaryEntries: N,
  loadPeriods: D,
  withPasteOptions: J,
  withDisplayOptions: p
}) {
  const [Q, _] = Dt(!1), T = nt(), I = it(), z = ct(), H = S(() => mo(A, o != null && o.viewCode ? [o.viewCode] : []), [A, o == null ? void 0 : o.viewCode]), f = S(() => Wt({
    dashboardSelection: $,
    chartPeriod: a
  }, !0), [$, a]), x = he(f), R = B(() => {
    o && u(o);
  }, [u, o]), P = B((q) => {
    if (E || Ae.info({
      duration: 2.5,
      key: "copied-metric-fail",
      message: T.get("configuration-metric-options.metric-copy-fail"),
      description: T.get("configuration-metric-options.metric-copy-fail-description"),
      placement: "bottomRight"
    }), o && E) {
      const Z = wt(o, H);
      l(rt(e), q.length > 0 ? jt(Nt({
        ...Z,
        ...Y.pick(wt(E, H), q)
      }, Z)) : E);
    }
  }, [H, E, e, T, l, o]), tt = B((q) => {
    o && l(rt(e), jt(Nt(q.reduce((Z, pt) => ({
      ...Z,
      [pt]: Y.isArray(Z[pt]) ? [] : void 0
    }), wt(o, H)), o)));
  }, [H, e, l, o]), Lt = xt(I, "auto", 14), Tt = xt(I, "none", 10);
  return /* @__PURE__ */ w(lo, { gutter: [0, 5], style: { width: "100%" }, children: [
    /* @__PURE__ */ t(U, { span: 24, style: { maxHeight: 40 }, children: /* @__PURE__ */ w(hn, { wrap: !1, children: [
      /* @__PURE__ */ t(U, { ...Lt, children: /* @__PURE__ */ t(
        go,
        {
          environmentId: i,
          id: e,
          value: o,
          groupMetricsByView: h,
          viewsWithMetrics: d,
          unavailableViews: c,
          canInvert: r,
          canRemove: s,
          onChange: l,
          onDelete: m,
          configuration: y,
          numberOfSlicer: L,
          getPopupContainer: b,
          isAxisOptionAvailable: k,
          isAxisOptionDisabled: e === 1,
          metaModel: A,
          dashboardSelection: $,
          period: a
        }
      ) }),
      /* @__PURE__ */ t(U, { ...Tt, children: /* @__PURE__ */ t(fn, { environmentId: i, availableDimensions: H, id: e, value: o, groupMetricsByView: h, viewsWithMetrics: d, unavailableViews: c, optionsDisabled: g, canInvert: r, canRemove: s, onChange: l, onDelete: m, configuration: y, numberOfSlicer: L, getPopupContainer: b, isAxisOptionAvailable: k, isAxisOptionDisabled: e === 1, displayType: C, metaModel: A, dashboardSelection: $, period: a, setActiveKey: (q) => {
        z.current = q;
      }, activeKey: z.current, handleDuplicate: R, handlePaste: P, copiedMetric: E, onCopy: M, isOptionsDisplayed: Q, setIsOptionsDisplayed: _, getMoreInformationLink: K, loadDictionaryEntries: N, loadPeriods: D, layout: I, withPasteOptions: J, withDisplayOptions: p }) })
    ] }) }),
    /* @__PURE__ */ t(
      io,
      {
        iconSize: 14,
        value: o,
        additionnalStyle: "width: 65%; margin-left: 3%;",
        isNameDisplayed: !0,
        timeInterval: f,
        dayDifference: x,
        setActiveKey: (q) => {
          _(q !== void 0), z.current = q;
        },
        onDelete: tt
      }
    )
  ] });
}), hn = F(dt)`
    align-items: center
`, pr = V(function({
  environmentId: e,
  value: i = [],
  onChange: o,
  viewsWithMetrics: r,
  unavailableViews: s,
  groupMetricsByView: l = !1,
  optionsDisabled: u = !1,
  multiple: m = !1,
  invertible: h = !1,
  getPopupContainer: d,
  configuration: c,
  numberOfSlicer: g,
  metaModel: y,
  displayType: L,
  format: b,
  dashboardSelection: k,
  period: C,
  onCopy: $,
  copiedMetric: a,
  getMoreInformationLink: A,
  loadDictionaryEntries: M,
  loadPeriods: E,
  withPasteOptions: K = !0,
  withDisplayOptions: N = !0
}) {
  const D = nt(), J = so(L, b), p = S(
    () => {
      const f = i.filter((x, R) => m || R === 0).filter((x) => {
        var R;
        return (R = r.find(({ code: P }) => P === x.viewCode)) == null ? void 0 : R.metrics.find(({ code: P }) => P === x.metricCode);
      });
      return Y.isEqual(f, i) ? i : f;
    },
    [i, m, r]
  );
  po(o, i, p), vt(() => {
    var f, x;
    p && p.length > 0 && ((x = (f = p[0]) == null ? void 0 : f.extraConf) != null && x.isDisplayedOnSecondaryAxis) && (o == null || o([{
      ...p[0],
      extraConf: {
        ...p[0].extraConf,
        isDisplayedOnSecondaryAxis: !1
      }
    }, ...p.slice(1)]));
  }, [o, p]);
  const Q = B(
    (f) => {
      o == null || o(p.slice(0, f).concat(p.slice(f + 1)));
    },
    [p, o]
  ), _ = ao(), T = co(), I = B(
    (f, x) => {
      const R = oe(y, x), P = x && R ? It({ ...x, metricDef: R }, D) : void 0, tt = x && r && P ? ne(r, {
        metricCode: `${x.metricCode}`,
        metricAlias: P,
        viewCode: x.viewCode
      }, l) : void 0;
      o == null || o(p.slice(0, f).concat([{
        ...x,
        ...T(f, x, p, y),
        metricAlias: tt ?? "",
        metricDef: R
      }], p.slice(f + 1)));
    },
    [l, D, y, T, o, p, r]
  ), z = B(
    (f) => {
      const x = oe(y, f), R = f && x ? It({ ...f, metricDef: x }, D) : void 0, P = f && r && R ? ne(r, {
        metricCode: `${f.metricCode}`,
        metricAlias: R,
        viewCode: f.viewCode
      }, l) : void 0;
      o == null || o([...p, {
        ...f,
        ..._(p.length, f, p, y),
        metricAlias: P ?? "",
        metricDef: x
      }]);
    },
    [y, D, r, l, o, p, _]
  ), H = S(() => p.length > 1 && L && J, [L, J, p.length]);
  return /* @__PURE__ */ w("div", { children: [
    /* @__PURE__ */ t(
      _e,
      {
        value: p,
        handleChange: o,
        overlayRender: (f) => /* @__PURE__ */ t(He, { activeId: f, children: /* @__PURE__ */ t(fe, { environmentId: e, id: f, value: p[rt(f)], groupMetricsByView: l, viewsWithMetrics: r, unavailableViews: s, optionsDisabled: u, canInvert: h, canRemove: m, onChange: I, onDelete: Q, configuration: c, numberOfSlicer: g, getPopupContainer: d, displayType: L, metaModel: y, dashboardSelection: k, period: C, copiedMetric: a, handleAdd: z, onCopy: () => $ == null ? void 0 : $(p[rt(f)]), getMoreInformationLink: A, loadDictionaryEntries: M, loadPeriods: E, withPasteOptions: K, withDisplayOptions: N }) }),
        children: p.map((f, x) => {
          var R, P;
          return /* @__PURE__ */ t(
            We,
            {
              id: te(x),
              children: /* @__PURE__ */ t(fe, { environmentId: e, id: te(x), value: f, groupMetricsByView: l, viewsWithMetrics: r, unavailableViews: s, optionsDisabled: u, canInvert: h, canRemove: m, onChange: I, onDelete: Q, handleAdd: z, configuration: c, numberOfSlicer: g, getPopupContainer: d, isAxisOptionAvailable: H, isAxisOptionDisabled: x === 0, displayType: L, metaModel: y, dashboardSelection: k, period: C, copiedMetric: a, onCopy: () => $ == null ? void 0 : $(f), getMoreInformationLink: A, loadDictionaryEntries: M, loadPeriods: E, withPasteOptions: K, withDisplayOptions: N })
            },
            `${f.metricCode}-${(R = f.growth) == null ? void 0 : R.period}-${(P = f.growth) == null ? void 0 : P.type}-${x}`
          );
        })
      }
    ),
    /* @__PURE__ */ t(wn, { children: (m || p.length === 0) && /* @__PURE__ */ t(ro, { environmentId: e, id: p.length, value: void 0, defaultView: p.length > 0 ? p[p.length - 1].viewCode : void 0, groupMetricsByView: l, viewsWithMetrics: r, unavailableViews: s, canInvert: h, canRemove: !1, handleAdd: z, getPopupContainer: d, displayType: L, metaModel: y, dashboardSelection: k, period: C, copiedMetric: a, withPasteOptions: K }) })
  ] });
}), wn = F.div`
    display: flex;
`, j = ({
  name: n,
  title: e,
  activated: i = !0,
  initialValue: o,
  additionalComponent: r,
  textAlignment: s = "center",
  contentSpan: l,
  textSpan: u,
  contentMargin: m = 0,
  rules: h,
  children: d
}) => {
  const c = S(() => h != null && h.find((b) => typeof b == "object" ? b.required : !1) ? 1 : 0, [h]), g = it(), y = S(() => l ?? (g === "compact" ? 24 : 17), [l, g]), L = S(() => u ?? (g === "compact" ? 24 : 7), [g, u]);
  return /* @__PURE__ */ w(xn, { $activated: i ? 1 : 0, children: [
    /* @__PURE__ */ t(vn, { span: L, $textalignment: s, $required: c, children: e }),
    /* @__PURE__ */ t(Cn, { span: y, $margin: m, children: /* @__PURE__ */ t(Be, { name: n, initialValue: o, rules: h, children: d }) }),
    r
  ] });
}, xn = F(dt)`
    ${({ $activated: n }) => n ? "" : "color: var(--medium-grey);"}
`, vn = F(U)`
    display: flex;
    align-items: ${({ $textalignment: n }) => n};
    height: 40px;

    ${({ $required: n }) => n ? ` &::before {
        display: inline-block;
        margin-inline-end: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: "*";
    }` : ""}
`, Cn = F(U)`
    display: flex;
    align-items: center;
    margin: ${({ $margin: n }) => n}px;
`, yn = V(({
  availableDimensions: n,
  environmentId: e,
  temporaryMetric: i,
  onMetricChange: o,
  loadDictionaryEntries: r,
  withDisplayOptions: s
}) => {
  const l = nt(), u = it(), [m] = ot.useForm(), h = kt(i, []), d = ct(null), c = S(() => i.additionalFilters.map((g) => `${g.reference.alias}: ${Do(g, l)}`).join(", "), [l, i.additionalFilters]);
  return /* @__PURE__ */ t(ot, { form: m, fields: h, onValuesChange: (g) => {
    o({
      ...g,
      ...Object.keys(g)[0] === "additionalFilters" && g.additionalFilters.length === 0 ? {
        additionalFiltersLabel: void 0
      } : {}
    });
  }, children: /* @__PURE__ */ t(yt, { ref: d, $layout: u, children: /* @__PURE__ */ w(bt, { $layout: u, children: [
    /* @__PURE__ */ t(
      j,
      {
        name: "additionalFilters",
        title: l.get("configuration-label-filters"),
        textAlignment: "center",
        children: /* @__PURE__ */ t(Uo, { availableDimensions: n, environmentId: e, GACategory: "metric-options", span: 24, loadDictionaryEntries: r, isEditable: !0 })
      }
    ),
    s && /* @__PURE__ */ t(
      j,
      {
        name: "additionalFiltersLabel",
        title: l.get("configuration-metric-options.custom-display"),
        textAlignment: "center",
        children: /* @__PURE__ */ t(Bt, { defaultLabel: c })
      }
    )
  ] }) }) });
});
var bn = /* @__PURE__ */ ((n) => (n.K = "K", n.M = "M", n))(bn || {});
const kn = V(({
  environmentId: n,
  temporaryMetric: e,
  onMetricChange: i,
  loadPeriods: o,
  withDisplayOptions: r
}) => {
  const s = nt(), l = it(), [u] = ot.useForm(), m = kt(e, []), h = ct(null), d = S(() => e.overridePeriod ? s.getTranslatedName(e.overridePeriod) : "", [s, e.overridePeriod]);
  return /* @__PURE__ */ t(ot, { form: u, fields: m, onValuesChange: (c) => {
    i({
      ...c,
      ...Object.keys(c)[0] === "overridePeriod" && Y.isEmpty(c.overridePeriod) ? {
        overridePeriodLabel: void 0
      } : {}
    });
  }, children: /* @__PURE__ */ t(yt, { ref: h, $layout: l, children: /* @__PURE__ */ w(bt, { $layout: l, children: [
    /* @__PURE__ */ t(
      j,
      {
        name: "overridePeriod",
        title: s.get("configuration-metric-options.period.title"),
        children: /* @__PURE__ */ t(
          Ge,
          {
            name: "overridePeriod",
            environmentId: n,
            overrideOptionLabel: s.get("configuration-metric-options.period.override-option-label"),
            span: 24,
            forTarget: !1,
            withDateSlicerGranularity: !1,
            withOverrideOption: !0,
            GACategory: "metric-options",
            loadPeriods: o
          }
        )
      }
    ),
    r && /* @__PURE__ */ t(
      j,
      {
        name: "overridePeriodLabel",
        title: s.get("configuration-metric-options.custom-display"),
        textAlignment: "center",
        children: /* @__PURE__ */ t(Bt, { defaultLabel: d })
      }
    )
  ] }) }) });
}), Ln = V(({
  id: n,
  temporaryMetric: e,
  configuration: i,
  onMetricChange: o,
  displayType: r,
  dayDifference: s,
  canInvert: l,
  dashboardSelection: u,
  period: m,
  withDisplayOptions: h
}) => {
  const d = nt(), c = it(), [g] = ot.useForm(), y = kt(e, []), L = ct(null), b = fo(r), k = S(() => e != null && e.growthType && e.growthPeriod ? Je(
    {
      growth: {
        type: e.growthType,
        period: e.growthPeriod
      },
      titlePartOverrides: e.titlePartOverrides
    },
    d
  ) : void 0, [d, e == null ? void 0 : e.growthPeriod, e == null ? void 0 : e.growthType, e == null ? void 0 : e.titlePartOverrides]);
  return /* @__PURE__ */ t(ot, { form: g, fields: y, onValuesChange: (C) => {
    Object.keys(C)[0] === "activated" ? C.activated ? o({
      growthPeriod: {
        unit: ie.WEEK,
        quantity: 1
      },
      growthType: b,
      activated: !0
    }) : o({
      growthType: void 0,
      growthPeriod: void 0,
      activated: !1,
      growthLabel: void 0
    }) : Object.keys(C)[0] === "growthPeriod" ? o({
      growthType: (e == null ? void 0 : e.growthType) ?? $t.VALUE,
      growthPeriod: C.growthPeriod ? {
        ...C.growthPeriod,
        quantity: C.growthPeriod.quantity === null ? 1 : C.growthPeriod.quantity
      } : void 0
    }) : Object.keys(C)[0] === "growthType" ? o({
      growthType: C.growthType ?? $t.VALUE,
      growthPeriod: (e == null ? void 0 : e.growthPeriod) ?? {
        unit: ie.WEEK,
        quantity: 1
      }
    }) : o(C);
  }, children: /* @__PURE__ */ t(yt, { ref: L, $layout: c, children: /* @__PURE__ */ w(bt, { $layout: c, children: [
    /* @__PURE__ */ t(j, { name: "activated", title: d.get("configuration-metric-options.growth.activated"), children: /* @__PURE__ */ t(uo, {}) }),
    /* @__PURE__ */ t(
      j,
      {
        name: "growthType",
        title: d.get("configuration-metric-options.growth.type"),
        activated: !!(e != null && e.activated),
        children: /* @__PURE__ */ t(ho, { configuration: i, activated: !!(e != null && e.activated) })
      }
    ),
    /* @__PURE__ */ t(
      j,
      {
        name: "growthPeriod",
        title: d.get("configuration-metric-options.growth.period"),
        activated: !!(e != null && e.activated) && (e == null ? void 0 : e.growthType) !== void 0,
        additionalComponent: (e == null ? void 0 : e.growthPeriod) && /* @__PURE__ */ t(U, { span: 17, offset: 7, style: {
          marginTop: 10,
          display: "flex",
          alignItems: "center"
        }, children: u && /* @__PURE__ */ t(Tn, { children: oo(no(
          e.growthPeriod.unit,
          e.growthPeriod.quantity ?? void 0,
          Wt({ dashboardSelection: u, chartPeriod: m }, !0),
          s
        )) }) }),
        children: /* @__PURE__ */ t(
          wo,
          {
            id: n,
            dayDifference: s,
            period: m,
            dashboardSelection: u,
            activated: !!(e != null && e.activated)
          }
        )
      }
    ),
    l && e && e.growthPeriod && e.growthType !== $t.VALUE && /* @__PURE__ */ t(
      j,
      {
        name: "growthInvert",
        title: d.get("configuration-metric-options.growth.options"),
        children: /* @__PURE__ */ t(xo, {})
      }
    ),
    h && /* @__PURE__ */ t(
      j,
      {
        name: "growthLabel",
        title: d.get("configuration-metric-options.growth.display"),
        activated: !!(e != null && e.activated) && (e == null ? void 0 : e.growthType) !== void 0,
        children: /* @__PURE__ */ t(
          Bt,
          {
            activated: !!(e != null && e.activated) && (e == null ? void 0 : e.growthType) !== void 0,
            defaultLabel: k
          }
        )
      }
    )
  ] }) }) });
}), Tn = F.div`
    font-weight: 500;
    font-size: 15px;
    line-height: 22.5px;
    text-align: right;
    color: rgba(0, 0, 0, 0.2);
`;
var Sn = /* @__PURE__ */ ((n) => (n.K = "K", n.M = "M", n))(Sn || {});
const $n = V(({
  temporaryMetric: n,
  onMetricChange: e,
  configuration: i
}) => {
  var h, d, c;
  const o = nt(), r = it(), [s] = ot.useForm(), l = kt(n, []), u = ct(null), m = Lo(e);
  return /* @__PURE__ */ t(ot, { form: s, fields: l, onValuesChange: m, children: /* @__PURE__ */ t(yt, { ref: u, $layout: r, children: /* @__PURE__ */ w(bt, { $layout: r, children: [
    /* @__PURE__ */ t(
      j,
      {
        name: "decimals",
        title: o.get("configuration-metric-options.display.decimals"),
        contentSpan: 5,
        children: /* @__PURE__ */ t(vo, { defaultLabel: ((h = n.metricDef) == null ? void 0 : h.formatPrecision) ?? 0, gaevent: {
          category: "metric-options",
          action: "update-decimals"
        } })
      }
    ),
    Y.isEmpty((d = n.metricDef) == null ? void 0 : d.formatPrefix) && Y.isEmpty((c = n.metricDef) == null ? void 0 : c.formatSuffix) && /* @__PURE__ */ t(
      j,
      {
        name: "details",
        title: o.get("configuration-metric-options.display.details.title"),
        children: /* @__PURE__ */ t(Co, { gaevent: {
          category: "metric-options",
          action: "update-details"
        } })
      }
    ),
    ge(n) && /* @__PURE__ */ t(
      j,
      {
        name: "units",
        title: o.get("configuration-metric-options.display.units.title"),
        contentSpan: 8,
        children: /* @__PURE__ */ t(ee, { gaevent: {
          category: "metric-options",
          action: "update-units"
        }, dropdownMatchSelectWidth: !1, options: [{
          value: null,
          label: /* @__PURE__ */ w(zt, { children: [
            /* @__PURE__ */ t(Ot, { children: /* @__PURE__ */ t(Go, {}) }),
            /* @__PURE__ */ t(Et, { children: "-" }),
            /* @__PURE__ */ t(At, { children: o.get("configuration-metric-options.display.units.options.units") })
          ] })
        }, {
          value: "K",
          label: /* @__PURE__ */ w(zt, { children: [
            /* @__PURE__ */ t(Ot, { children: "k" }),
            /* @__PURE__ */ t(Et, { children: "-" }),
            /* @__PURE__ */ t(At, { children: o.get("configuration-metric-options.display.units.options.k") })
          ] })
        }, {
          value: "M",
          label: /* @__PURE__ */ w(zt, { children: [
            /* @__PURE__ */ t(Ot, { children: "M" }),
            /* @__PURE__ */ t(Et, { children: "-" }),
            /* @__PURE__ */ t(At, { children: o.get("configuration-metric-options.display.units.options.m") })
          ] })
        }] })
      }
    ),
    /* @__PURE__ */ w(dt, { children: [
      /* @__PURE__ */ t(U, { span: 14, children: /* @__PURE__ */ t(
        j,
        {
          name: "type",
          title: o.get("configuration-metric-options.display.type.title"),
          textSpan: 12,
          contentSpan: 12,
          initialValue: null,
          children: /* @__PURE__ */ t(ee, { gaevent: {
            category: "metric-options",
            action: "update-type"
          }, options: [{
            value: null,
            label: o.get("configuration-metric-options.display.type.options.default")
          }, {
            value: W.fixed,
            label: o.get(`configuration-metric-options.display.type.options.${W.fixed}`)
          }, {
            value: W.interval,
            label: o.get(`configuration-metric-options.display.type.options.${W.interval}`)
          }, {
            value: W.gradient,
            label: o.get(`configuration-metric-options.display.type.options.${W.gradient}`)
          }] })
        }
      ) }),
      !(i != null && i.isColorOverridable) && n.type === W.fixed && /* @__PURE__ */ t(U, { span: 9, offset: 1, children: /* @__PURE__ */ w(Pt, { children: [
        /* @__PURE__ */ t(O, { children: /* @__PURE__ */ t(Ft, {}) }),
        o.get("configuration-metric-options.display.color-warning")
      ] }) }),
      !(i != null && i.isGradiantAvailable) && n.type === W.gradient && /* @__PURE__ */ t(U, { span: 9, offset: 1, children: /* @__PURE__ */ w(Pt, { children: [
        /* @__PURE__ */ t(O, { children: /* @__PURE__ */ t(Ft, {}) }),
        o.get("configuration-metric-options.display.color-warning-gradient")
      ] }) }),
      !(i != null && i.isIntervalAvailable) && n.type === W.interval && /* @__PURE__ */ t(U, { span: 9, offset: 1, children: /* @__PURE__ */ w(Pt, { children: [
        /* @__PURE__ */ t(O, { children: /* @__PURE__ */ t(Ft, {}) }),
        o.get("configuration-metric-options.display.color-warning-interval")
      ] }) })
    ] }),
    n.type === W.interval && /* @__PURE__ */ t(
      j,
      {
        name: W.interval,
        title: "",
        children: /* @__PURE__ */ t(yo, {})
      }
    ),
    n.type === W.fixed && /* @__PURE__ */ t(
      j,
      {
        name: "color",
        title: "",
        initialValue: null,
        contentSpan: 8,
        children: /* @__PURE__ */ t(bo, {})
      }
    ),
    n.type === W.gradient && /* @__PURE__ */ t(
      j,
      {
        name: W.gradient,
        title: "",
        contentSpan: 16,
        children: /* @__PURE__ */ t(ko, {})
      }
    )
  ] }) }) });
}), Pt = F.div`
    display: flex;
    justify-content: end;
    text-align: left;
    font-size: 0.7em;
    line-height: 1em;
    color: var(--light-text);
    align-items: center;
    gap: 8px;
    height: 100%;
`, Ot = F.span`
    min-width: 20px;
`, Et = F.span`
    min-width: 15px;
`, At = F.span`
    font-style: italic;
`, zt = F.div`
    display: flex;
`, Fn = V(({
  id: n,
  availableDimensions: e,
  environmentId: i,
  value: o,
  configuration: r,
  onValuesChange: s,
  dashboardSelection: l,
  displayType: u,
  canInvert: m,
  dayDifference: h,
  period: d,
  onCancel: c,
  activeKey: g,
  metaModel: y,
  loadDictionaryEntries: L,
  loadPeriods: b,
  withDisplayOptions: k
}) => {
  var x, R;
  const C = nt(), $ = it(), [a, A] = Dt(wt(o, e)), M = Ue({
    growth: a && a.growthType && a.growthPeriod ? {
      type: a.growthType,
      period: a.growthPeriod
    } : void 0
  }), E = Ke({ additionalFilters: (a == null ? void 0 : a.additionalFilters) ?? [] }), K = Ze({ overridePeriod: a == null ? void 0 : a.overridePeriod }), N = Xe({
    extraConf: {
      details: Y.isEqual(a.details, (x = o.extraConf) == null ? void 0 : x.details) ? a.details : void 0,
      units: a.units ?? void 0,
      decimals: Y.isEqual(a.decimals, (R = o.extraConf) == null ? void 0 : R.decimals) ? a.decimals : void 0,
      color: a.color ?? void 0
    }
  }), D = B((P) => {
    const tt = {
      ...a,
      ...P
    };
    A({
      ...tt,
      additionalFilters: me(tt.additionalFilters, e)
    });
  }, [e, a]), J = B(() => {
    a && s(jt(Nt(a, o)));
  }, [s, a, o]), p = B(() => {
    o && A((P) => ({
      ...P,
      growthType: void 0,
      growthPeriod: void 0,
      activated: !1,
      additionalFilters: [],
      color: null,
      units: null,
      overridePeriod: void 0,
      overridePeriodLabel: void 0,
      additionalFiltersLabel: void 0,
      growthLabel: void 0,
      label: void 0
    }));
  }, [o]), Q = S(() => It(a, C), [C, a]);
  vt(() => {
    T(g);
  }, [g]);
  const [_, T] = Dt(g), I = S(() => /* @__PURE__ */ t(yn, { environmentId: i, availableDimensions: e, temporaryMetric: a, onMetricChange: D, loadDictionaryEntries: L, withDisplayOptions: k, layout: $ }), [e, i, $, L, D, a, k]), z = S(() => /* @__PURE__ */ t(kn, { environmentId: i, temporaryMetric: a, onMetricChange: D, metaModel: y, loadPeriods: b, withDisplayOptions: k }), [i, b, y, D, a, k]), H = S(() => /* @__PURE__ */ t(Ln, { id: n, temporaryMetric: a, configuration: r, onMetricChange: D, dashboardSelection: l, displayType: u, canInvert: m, dayDifference: h, period: d, withDisplayOptions: k }), [m, r, l, h, u, n, D, d, a, k]), f = S(() => /* @__PURE__ */ t($n, { environmentId: i, configuration: r, temporaryMetric: a, onMetricChange: D, metaModel: y }), [r, i, y, D, a]);
  return /* @__PURE__ */ w("div", { children: [
    /* @__PURE__ */ w(Pn, { "data-testid": "title", children: [
      Q,
      $ === "default" && /* @__PURE__ */ t(O, { clickable: !0, onClick: c, children: /* @__PURE__ */ t(Ho, {}) })
    ] }),
    $ === "default" ? /* @__PURE__ */ t(
      On,
      {
        tabPosition: $ === "default" ? "left" : "top",
        activeKey: _,
        onChange: (P) => T == null ? void 0 : T(P),
        items: [{
          active: _ === X.filters,
          key: X.filters,
          label: /* @__PURE__ */ w(ht, { $modified: E ? 1 : 0, children: [
            /* @__PURE__ */ t(O, { size: 22, children: /* @__PURE__ */ t(So, {}) }),
            C.get("configuration-metric-options.filters.title")
          ] }),
          children: I
        }, {
          active: _ === X.period,
          key: X.period,
          label: /* @__PURE__ */ w(ht, { $modified: K ? 1 : 0, children: [
            /* @__PURE__ */ t(O, { size: 22, children: /* @__PURE__ */ t($o, {}) }),
            C.get("configuration-metric-options.period.title")
          ] }),
          children: z
        }, {
          active: _ === X.growth,
          key: X.growth,
          label: /* @__PURE__ */ w(ht, { $modified: M ? 1 : 0, children: [
            /* @__PURE__ */ t(O, { size: 22, children: /* @__PURE__ */ t(Fo, {}) }),
            C.get("configuration-metric-options.growth.title")
          ] }),
          children: H
        }].concat(k ? [{
          active: _ === X.display,
          key: X.display,
          label: /* @__PURE__ */ w(ht, { $modified: N ? 1 : 0, children: [
            /* @__PURE__ */ t(O, { size: 22, children: /* @__PURE__ */ t(Ro, {}) }),
            C.get("configuration-metric-options.display.title")
          ] }),
          children: f
        }] : [])
      }
    ) : /* @__PURE__ */ t(
      ze,
      {
        size: "small",
        bordered: !1,
        items: [{
          key: "dimensionFilters",
          label: /* @__PURE__ */ t(En, {}),
          children: I
        }, {
          key: "period",
          label: /* @__PURE__ */ t(An, {}),
          children: z
        }, {
          key: "growth",
          label: /* @__PURE__ */ t(zn, {}),
          children: H
        }].concat(k ? [{
          key: "display",
          label: /* @__PURE__ */ t(Dn, {}),
          children: f
        }] : [])
      }
    ),
    /* @__PURE__ */ t(
      To,
      {
        onReset: p,
        onSave: J,
        onCancel: c
      }
    )
  ] });
}), Rn = Fn, Pn = F.div`
    display: flex;
    font-weight: 600;
    padding: 4px 20px;
    border-bottom: 1px solid var(--main-background-color);
    justify-content: space-between;
    align-items: center;
`, ht = F.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    gap: 13px;
    ${({ $modified: n }) => n ? "color: var(--primary);" : ""}
`, On = F(De)`
    .ant-tabs-content {
        display: flex;
        flex-direction: column;
    }

    .ant-tabs-content {
        height: 100%;
        display: flex;
        justify-content: space-between;
    }

    .ant-tabs-tab-active {
        background-color: #D9DFFC;
    }

    &&& .ant-tabs-nav-wrap {
        padding-right: 10px !important;
    }

    .ant-tabs-tab {
        padding: 4px 8px;
        margin: 0 0 0 0;
    }
`, En = () => /* @__PURE__ */ t(Ct, { icon: qe, label: "configuration-label-filters", display: "block", layout: "flex" }), An = () => /* @__PURE__ */ t(
  Ct,
  {
    icon: pe,
    label: "configuration-label-period",
    display: "block",
    layout: "flex"
  }
), zn = () => /* @__PURE__ */ t(
  Ct,
  {
    icon: Ce,
    label: "configuration-metric-options.growth.title",
    display: "block",
    layout: "flex"
  }
), Dn = () => /* @__PURE__ */ t(
  Ct,
  {
    icon: ve,
    label: "configuration-metric-options.display.title",
    display: "block",
    layout: "flex"
  }
);
export {
  Uo as D,
  j as F,
  $n as M,
  Sn as U,
  yn as a,
  kn as b,
  Rn as c,
  fn as d,
  pr as e,
  fe as f,
  bn as g,
  Ln as h
};
//# sourceMappingURL=MetricOptionsForm-DG-QO14f.js.map
